import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=fcfffe94&"
import script from "./ValidateEmail.vue?vue&type=script&lang=ts&"
export * from "./ValidateEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports